module.exports = __webpack_public_path__ + "img/Search.7aaf63e4.svg";